import styled from "@emotion/styled";
import { Menu } from "@mui/material";

export const MenuStyle = styled(Menu)({
  "hr": {
    border: "0",
    borderBottom: "1px solid",
    margin: "10px 25px",
    color: "#4c5e78",
  },
  "& .avatar-name": {
    display: "flex",
    flexDirection: "column",
    gap: "0.7rem",
    alignItems: "self-start",
    cursor: "default",
    ".MuiTouchRipple-root": {
      display: "none"
    },
    ":hover": {
      backgroundColor: "unset"
    }
  },
  "& .MuiMenu-list": {
    minWidth: "200px",
    alignItems: "self-start",
  },
  "& .profile p": {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    "svg": {
      fontSize: "1.3rem"
    }
  },
  "& .invitation_code": {
    "p": {
      display: "flex",
      alignItems: "center",
      gap: "1rem",
    },
    ".invitation_code-text": {
      display: "inline",
    },
    ".the-code": {
      display: "none",
    },
    "&:hover": {
      ".invitation_code-text": {
        display: "none",
      },
      ".the-code": {
        display: "inline",
      }
    }
  },
  "& .MuiMenuItem-gutters": {
    minHeight: "unset",
  }
});
